"use client";
import * as React from "react";
const SvgSortFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 11.5h5.33V9.67H0zm0-11v1.83h16V.5zm0 6.42h10.67V5.08H0z" }));
export {
  SvgSortFilled as default
};
